import { render, staticRenderFns } from "./ProductShippingInfo.vue?vue&type=template&id=bc92c9a6&"
import script from "./ProductShippingInfo.vue?vue&type=script&lang=js&"
export * from "./ProductShippingInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports